import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ComplianceIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_compliance)">
        <path
          d="M3.33337 11.5V5.83329C3.33337 4.82077 4.15418 3.99996 5.16671 3.99996H6.00004C6.27618 3.99996 6.50004 4.22382 6.50004 4.49996C6.50004 4.7761 6.27618 4.99996 6.00004 4.99996H5.16671C4.70647 4.99996 4.33337 5.37306 4.33337 5.83329V11.5C4.33337 11.9602 4.70646 12.3333 5.16671 12.3333H10.8334C11.2936 12.3333 11.6667 11.9602 11.6667 11.5V5.83329C11.6667 5.37305 11.2936 4.99996 10.8334 4.99996H10C9.7239 4.99996 9.50004 4.7761 9.50004 4.49996C9.50004 4.22382 9.7239 3.99996 10 3.99996H10.8334C11.8459 3.99996 12.6667 4.82078 12.6667 5.83329V11.5C12.6667 12.5125 11.8459 13.3333 10.8334 13.3333H5.16671C4.15419 13.3333 3.33337 12.5125 3.33337 11.5Z"
          fill="currentColor"
        />
        <path
          d="M9.50004 3.83329C9.50004 3.74124 9.42542 3.66663 9.33337 3.66663H6.66671C6.57466 3.66663 6.50004 3.74125 6.50004 3.83329V4.83329C6.50004 4.92534 6.57466 4.99996 6.66671 4.99996H9.33337C9.42542 4.99996 9.50004 4.92534 9.50004 4.83329V3.83329ZM10.5 4.83329C10.5 5.47762 9.97772 5.99996 9.33337 5.99996H6.66671C6.02238 5.99996 5.50004 5.47762 5.50004 4.83329V3.83329C5.50004 3.18896 6.02238 2.66663 6.66671 2.66663H9.33337C9.97772 2.66663 10.5 3.18897 10.5 3.83329V4.83329Z"
          fill="currentColor"
        />
        <path
          d="M9.50004 7.66663C9.77618 7.66663 10 7.89048 10 8.16663C10 8.44277 9.77618 8.66663 9.50004 8.66663H6.50004C6.2239 8.66663 6.00004 8.44277 6.00004 8.16663C6.00004 7.89048 6.2239 7.66663 6.50004 7.66663H9.50004Z"
          fill="currentColor"
        />
        <path
          d="M9.50004 9.66663C9.77618 9.66663 10 9.89048 10 10.1666C10 10.4428 9.77618 10.6666 9.50004 10.6666H6.50004C6.2239 10.6666 6.00004 10.4428 6.00004 10.1666C6.00004 9.89048 6.2239 9.66663 6.50004 9.66663H9.50004Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_compliance">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
